import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./Auth";

/*
 * Route that is protected with authentication. Assumes that we have an auth context
 * that contains a current user.
 *
 * adminOnly: is the current route only for admins with access to cms?
 */
const AuthenticatedRoute = ({ adminOnly = false, ...props }) => {
  const { currentUser } = useContext(AuthContext);

  // Check if user has admin access using the actual field names from the profile
  const hasAdminAccess = currentUser?.admin_cms === true || currentUser?.isAdminOnCMS === true;

  console.log("AuthenticatedRoute check:", {
    path: props.path,
    adminOnly,
    currentUser: currentUser ? { ...currentUser, id: currentUser.id } : null,
    admin_cms: currentUser?.admin_cms,
    isAdminOnCMS: currentUser?.isAdminOnCMS,
    hasAdminAccess,
    hasAccess: adminOnly ? hasAdminAccess : !!currentUser
  });

  // non admin routes must be authenticated
  // admin routes must have admin access (admin_cms or isAdminOnCMS)
  if (!adminOnly && !!currentUser) {
    console.log("Non-admin route - user authenticated, allowing access");
    return <Route {...props} />;
  } else if (adminOnly && hasAdminAccess) {
    console.log("Admin route - user has admin access, allowing access");
    return <Route {...props} />;
  }

  console.log("Access denied, redirecting to 404");
  return <Redirect to={"/404"} />;
};

export default AuthenticatedRoute;
